import { HarmonizedTracking } from '@/helpers/GTM/GTMParameters';

function isGTMEnabled(): boolean {
  return !!window.dataLayer;
}

export const TRACK_EVENT_PARAMS_DEFAULT: Record<string, string | number | undefined> = {
  interaction_sysFeedback: undefined,
  interaction_error: undefined,
  interaction_containerName: undefined,
  interaction_containerDetail: undefined,
  interaction_element: undefined,
  interaction_mode: undefined,
  interaction_goal: undefined,
  h_interaction_containername_052: undefined,
  h_interaction_element_055: undefined,
  h_interaction_mode_059: undefined,
  h_interaction_goal_054: undefined,
  interaction_actor: undefined,
  lead_type: undefined,
  tech_leadId: undefined,
  client_sns_subscriptionId: undefined,
  page_targetUrl: undefined,
  page_teaserName_displayed: undefined,
};

/**
 * Functions interacting directly with dataLayer.
 */
export function trackEventHarmonized(
  eventName: string,
  eventParams: HarmonizedTracking = {},
): void {
  if (!isGTMEnabled()) {
    return;
  }

  setTimeout(() =>
    window.dataLayer.push({
      ...eventParams,
      event: eventName,
    }),
  );
}
